import { InputType } from 'config'

/** Read-only column definitions for the secondary employment list (Labels + cell typing for formatTableCell). */
export const getSecondaryEmploymentListInputDefs = (): Record<string, InputType> => ({
  employer: { inputType: 'text', title: 'Name' },
  address: { inputType: 'text', title: 'Address' },
  howLong: { inputType: 'text', title: 'How Long' },
  positionTitle: { inputType: 'text', title: 'Position' },
  selfEmployedOrBusinessOwner: { inputType: 'text', title: 'Self Emp.' },
  employedByFamilyOrParty: { inputType: 'text', title: 'Special Rel.' },
  incomeSummary: { inputType: 'text', title: 'Income' },
})

export const secondaryEmploymentListColumnKeys = [
  'employer',
  'address',
  'howLong',
  'positionTitle',
  'selfEmployedOrBusinessOwner',
  'employedByFamilyOrParty',
  'incomeSummary',
] as const

export const secondaryEmploymentListColumnHeaders: Record<string, string> = {
  employer: 'Name',
  address: 'Address',
  howLong: 'How Long',
  positionTitle: 'Position',
  selfEmployedOrBusinessOwner: 'Self Emp.',
  employedByFamilyOrParty: 'Special Rel.',
  incomeSummary: 'Income',
}
